<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>属性列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="20">
        <el-col :span="9">
          <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
              size="mini"
          >
            <el-form-item >
              <el-input v-model="searchForm.name" clearable type="text"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="success"  size="mini"  @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"  size="mini" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
          ref="multipleTable"
          :data="tableLoadData"
          height="450"
          stripe
          border
          size="mini"
      >
        <el-table-column  type="expand">
          <template slot-scope="scope">

            <el-table
                :data="scope.row.val"
            >
              <el-table-column label="规格">
                <template slot-scope="props">
                <span>
                  {{props.row.name}}
                </span>
                </template>
              </el-table-column>
              <!--              <el-table-column-->
              <!--                label="操作"-->
              <!--                width="180">-->
              <!--                <template slot-scope="props">-->
              <!--                  <el-button  type="text" size="mini" @click="delVal(props.row)">删除</el-button>-->
              <!--                </template>-->
              <!--              </el-table-column>-->

            </el-table>

          </template>

        </el-table-column>

        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column
            label="属性名称"
            width="120"
            prop="attr_name"
            :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
            label="所属分类"
            width="120"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.type!=null?scope.row.type.cat_name:""}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="输入类型"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.attr_input_type==0?'输入':(scope.row.attr_input_type==1?'选择':'')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="是否多选"
            width="100"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.attr_type==0?'单选':(scope.row.attr_type==1?'多选':'')}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            label="属性组"
            width="120"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.attr_group }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="排序"
            width="120"
            :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sort_order }}</span>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="180">
          <template slot-scope="scope">
            <el-button  type="text" size="mini" @click="del(scope.row)">删除</el-button>
            <el-button @click="goEdit(scope.row)"  type="text" size="mini">编辑</el-button>
            <el-button @click="addVal(scope.row)"  type="text" size="mini">添加规格</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <eAttr
        :formData="formData"
        :visible.sync="visible"
        :title="title"
        :closeForm="closeForm"
    />
    <eAttrVal
        :formData="formData1"
        :visible.sync="visible1"
        :title="title1"
        :closeForm="closeForm1"
    />
  </div>
</template>

<script>
import eAttr from "../common/eAttr.vue";
import eAttrVal from "../common/eAttrVal.vue";
import moment from 'moment'     //日期时间转换
export default {
  name: "attrList",
  components: {
    eAttr,eAttrVal
  },
  props: {},
  data() {
    return {
      formData:{},
      title:'',
      visible:false,

      formData1:{},
      title1:'',
      visible1:false,

      // 搜索
      searchForm: {
        name: "",
      },
      searchRules: {
        name: [
          { required: true, message: "请输入文章标题", trigger: "blur" }
        ],
      },
      // 数据
      tableLoadData: [],
      pageNum:1,// 当前页码
      pageSize:10,// 每页大小
      total:0,//总条目数

      showType: '',

      roleList: [],

      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          }
        ],

      },



    };
  },
  created() {
    this.showType = this.$route.query.showType;
    this.DataList()
    this.departData()
  },
  mounted() {
  },
  filters: {
    //时间格式化
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
    },


  },
  methods: {
    closeForm(){
      this.title="";
      this.pageNum=1;
      this.DataList();
      this.visible=false;
    },
    closeForm1(){
      this.title1="";
      this.pageNum=1;
      this.DataList();
      this.visible1=false;
    },
    addVal(row) {

      this.formData1.attr_id=row.attr_id;
      this.formData1.attr_name=row.attr_name;
      this.formData1.val=row.val;
      this.title1="新增产品规格";
      this.visible1=true;

    },
    addData() {
      this.title="新增产品属性";
      this.formData={};
      this.visible=true;
    },
    goEdit(row){

      this.title="修改产品属性";
      this.formData.attr_name=row.attr_name;
      this.formData.attr_input_type=row.attr_input_type;
      this.formData.cat_id=row.cat_id;
      this.formData.attr_id=row.attr_id;

      this.visible=true;
    },
    goCategory(){
      this.$router.push('/goodsCategoryList')
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    DataList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        shop_id:sessionStorage.getItem('shop_id')
      }
      this.$axios.goodsAttributesListP(param).then(res=>{
        if(res.code == 200){
          //  console.log(res,1111);
          this.tableLoadData = res.data.data
          this.total = res.data.total
        }
      }).catch(error=>{
        console.log(error);
      })
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    departData(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.findTree(param).then(res=>{
        if(res.code == 200){
          this.rightslist = res.data.data
        }
      }).catch(error=>{
        console.log(error);
      })
    },


    searchSubmit() {
      this.pageNum=1;
      this.DataList();
    },
    delVal(e){
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.id,
        }
        this.$axios.goodsAttributesValDel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.pageNum=1;
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          console.log(error);
        })
      }).catch(() => {
        // 点击取消:不删除了
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
        this.DataList()
      });
    },
    del(e) {
      this.$confirm('此操作将删除该属性, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          shop_id:sessionStorage.getItem('shop_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          attr_id: e.attr_id,
        }
        this.$axios.goodsAttributesDel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          console.log(error);
        })
      }).catch(() => {
        // 点击取消:不删除了
        this.$message({
          type: 'info',
          message: '已取消删除'
        });

      });

    },


  },
};
</script>
<style>

</style>
